/* jslint browser: true */
/* global window */
import React, { Component } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { loadProgressBar } from 'axios-progress-bar';
import Wrapper from './components/Wrapper';
import Header from './components/Header';
import Footer from './components/Footer';
import { devMode } from './lib/constants';

import './css/style.css';
import './css/bootstrap.min.css';
import './../node_modules/font-awesome/css/font-awesome.min.css';

class App extends Component {
    componentWillMount() {
        axios.defaults.onDownloadProgress = loadProgressBar();
        axios.defaults.headers.common.Authorization = window.localStorage.getItem(
            'token'
        );
        axios.defaults.headers.post['Content-Type'] = 'application/json';
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

        axios.interceptors.response.use(
            response => {
                if (devMode) {
                    // eslint-disable-next-line no-console
                    console.log(response);
                }
                return response;
            },
            err => {
                if (err.response) {
                    if (devMode) {
                        // eslint-disable-next-line no-console
                        console.error(err.response);
                    }
                    if (err.response.status === 500) {
                        toast.error(`Erreur 500: ${err.response.data}`);
                    } else if (err.response.status === 401) {
                        window.location.href = '/login?c';
                    } else if (
                        err.response.data === "Le hash n'est pas valide"
                    ) {
                        window.location.href = '/login?h';
                    } else if (err.response.status === 404) {
                        toast.warn(`Erreur 404: ${err.response.data}`);
                    } else if (err.response.status === 400) {
                        if (err.response.data === "Le hash n'est pas valide") {
                            window.location.href = '/login?h';
                        } else {
                            toast.warn(`Erreur 400: ${err.response.data}`);
                        }
                    } else {
                        toast.warn(`Erreur: ${err.response.data}`);
                    }
                } else {
                    toast.error(`Erreur: ${err.response}`);
                }
                return Promise.reject(err);
            }
        );
    }

    render() {
        return (
            <div>
                <ToastContainer className="toast-container" />
                <Header />
                <Wrapper />
                <Footer />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js